import { createApiMutationHook } from "@/hooks/use-api-mutation";
import { post } from "@/libs/http";
import { RummyGameUrlReq, RummyGameUrlRes } from "@/types/api/hall/rummy-game-url.d";


export const getGameUrl = ({ params }: { params: RummyGameUrlReq; }) => post<RummyGameUrlRes>('/hall/v1/rummy_game_url', params);

export const useGetGameUrl = createApiMutationHook(getGameUrl);

